import { z } from "zod";
import { FirestoreTimestampSchema } from "./common.schema";

/**
 * Zod schema for UserData documents in Firestore
 * Path: users/{userId}
 */
export const UserDataSchema = z.object({
  createdAt: FirestoreTimestampSchema,
  currentDomainId: z.string().nullish(),
  currentPageId: z.string().nullish(),
  displayName: z.string(),
  email: z.email("Must be a valid email"),
  firstName: z.string(),
  lastName: z.string(),
  updatedAt: FirestoreTimestampSchema.optional(),
  hasCompletedSetupWizard: z.boolean().optional(),
});

/**
 * TypeScript type inferred from Zod schema
 * This replaces the old UserData type from src/types/UserData.ts
 */
export type UserData = z.infer<typeof UserDataSchema>;

/**
 * Parse function that validates and throws on error (strict mode)
 */
export const parseUserData = (data: unknown): UserData => {
  return UserDataSchema.parse(data);
};

/**
 * Safe parse function that returns success/error object
 */
export const safeUserDataParse = (data: unknown) => {
  return UserDataSchema.safeParse(data);
};
